import { render, staticRenderFns } from "./AuthorAffairsList.vue?vue&type=template&id=a32c0c0c&scoped=true&"
import script from "./AuthorAffairsList.vue?vue&type=script&lang=js&"
export * from "./AuthorAffairsList.vue?vue&type=script&lang=js&"
import style0 from "./AuthorAffairsList.vue?vue&type=style&index=0&id=a32c0c0c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32c0c0c",
  null
  
)

export default component.exports